import styled from 'styled-components'
import { Link } from '@sketch/components'

export const ForgotPasswordLink = styled(Link)`
  font-size: ${({ theme }) => theme.fontSizes.C};
`
